import type React from "react"

import type { EnvelopeStatus } from "../types/esign.types.ts"

const pill = (color: string, backgroundColor: string): React.CSSProperties => ({
  color,
  backgroundColor,
  borderColor: backgroundColor
})

const IN_PROGRESS = pill("#1D4ED8", "#EFF6FF")
const DONE = pill("#367B38", "#E8F5E9")
const REFUSED = pill("#B91C1C", "#FEF2F2")
const CLOSED = pill("#475569", "#F1F5F9")

export const ENVELOPE_STATUS_STYLES: Record<
  EnvelopeStatus,
  React.CSSProperties
> = {
  draft: CLOSED,
  sent: IN_PROGRESS,
  partially_signed: IN_PROGRESS,
  signed: DONE,
  completed: DONE,
  declined: REFUSED,
  expired: CLOSED,
  voided: CLOSED
}

export const OVERDUE_STYLE = pill("#B91C1C", "#FEF2F2")
export const NEARING_EXPIRY_STYLE = pill("#9E5E00", "#FFF3E0")
